import { gql } from '../../../__generated__';

export const GET_BOOKS = gql(/* GraphQL */ `
  query Books_connection(
    $filters: BookFiltersInput
    $pagination: PaginationArg
  ) {
    books_connection(filters: $filters, pagination: $pagination) {
      pageInfo {
        total
        page
        pageSize
        pageCount
      }
      nodes {
        documentId
        title
        subject
        url
        author
        publishedYear
        description
        deletedAt
        uuid
        createdAt
        updatedAt
        publishedAt
        tokenCounts
        priceCounts
      }
    }
  }
`);

export const GET_FACT_CHECKS = gql(/* GraphQL */ `
  query FactChecks_connection(
    $filters: FactCheckFiltersInput
    $pagination: PaginationArg
    $sort: [String]
  ) {
    factChecks_connection(
      filters: $filters
      pagination: $pagination
      sort: $sort
    ) {
      pageInfo {
        total
        page
        pageSize
        pageCount
      }
      nodes {
        ocrText
        ocrResult
        isFactuallyCorrect
        documentId
        createdAt
        publishedAt
        totalPrice
        totalTokens
        inputPrice
        inputTokens
        outputTokens
        outputPrice
        reasoning
        uuid
        subSection {
          documentId
          asset {
            image {
              alternativeText
              url
            }
          }
          pageNumber
          feedback {
            factClientComments
            factDownvote
            factUpvote
          }
        }
        section {
          tokenCounts
          priceCounts
        }
        book {
          title
          tokenCounts
          priceCounts
        }
      }
    }
  }
`);

export const GET_CATEGORY_ANALYSES = gql(/* GraphQL */ `
  query CategoryAnalyses_connection(
    $pagination: PaginationArg
    $filters: CategoryAnalysisFiltersInput
    $sort: [String]
  ) {
    categoryAnalyses_connection(
      pagination: $pagination
      filters: $filters
      sort: $sort
    ) {
      pageInfo {
        total
        page
        pageSize
        pageCount
      }
      nodes {
        book {
          title
          tokenCounts
          priceCounts
        }
        subSection {
          documentId
          paragraphNumber
          pageNumber
          paragraph
          feedback {
            categoryClientComments
            categoryDownvote
            categoryUpvote
            suggestedCategory
            suggestedRating
          }
        }
        section {
          tokenCounts
          priceCounts
        }
        judgeSummary
        judgeOutput
        createdAt
        rating
        rightistOutput
        uuid
        validationPercentage
        leftistOutput
        publishedAt
        documentId
        category
        totalPrice
        totalTokens
        inputPrice
        inputTokens
        outputTokens
        outputPrice
        observedDeception
      }
    }
  }
`);

export const GET_SECTIONS = gql(/* GraphQL */ `
  query Sections_connection(
    $filters: SectionFiltersInput
    $pagination: PaginationArg
  ) {
    sections_connection(filters: $filters, pagination: $pagination) {
      nodes {
        title
        documentId
      }
      pageInfo {
        total
        page
        pageSize
        pageCount
      }
    }
  }
`);

export const GET_SEXUALLY_INAPPROPRIATE_ANALYSES = gql(`
  query SexuallyInappropriates(
    $pagination: PaginationArg
    $filters: SexuallyInappropriateFiltersInput
    $sort: [String]
  ) {
    sexuallyInappropriates_connection(
      pagination: $pagination
      filters: $filters
      sort: $sort
    ) {
      pageInfo {
        total
        page
        pageSize
        pageCount
      }
      nodes {
        documentId
        aiStages
        firstPersonPerspective
        physicalContactType
        setting
        explicitTermsFound
        anatomicalTermsPresent
        containsDialogue
        explicitTermsList
        anatomicalTermsList
        chromosomallyDefinedGender
        selfIdentifiedGenders
        sexualRelationshipType
        characterAge
        euphemismsList
        suggestivePhrasesList
        powerImbalancePresent
        tone
        excessiveFocusOnBodyDescription
        languageOfSecrecyOrConcealment
        roleplayOrFantasyContext
        violenceOverlap
        nudityDetected
        nudityExtent
        nudityType
        sexualActsDetected
        intentDetected
        outputTokens
        totalTokens
        inputPrice
        outputPrice
        totalPrice
        book {
          title
          tokenCounts
          priceCounts
        }
        section {
          tokenCounts
          priceCounts
          documentId
        }
        finalRating
        ratingReason
        inputTokens
        subSection {
          documentId
          paragraphNumber
          pageNumber
          paragraph
          feedback {
            suggestedFactCheck
            suggestedReasoning
            factClientComments
            categoryClientComments
            sexuallyClientComments
            religiousClientComments
            factUpvote
            factDownvote
            categoryUpvote
            categoryDownvote
            sexuallyUpvote
            sexuallyDownvote
            religiousUpvote
            religiousDownvote
            suggestedCategory
            suggestedRating
            sexuallyFirstPersonPerspective
            sexuallyPhysicalContactType
            sexuallySetting
            sexuallyExplicitTermsFound
            sexuallyAnatomicalTermsPresent
            sexuallyContainsDialogue
            sexuallyExplicitTermsList
            sexuallyAnatomicalTermsList
            sexuallyChromosomallyDefinedGender
            sexuallySelfIdentifiedGenders
            sexuallySexualRelationshipType
            sexuallyCharacterAge
            sexuallyEuphemismsList
            sexuallySuggestivePhrasesList
            sexuallyPowerImbalancePresent
            sexuallyTone
            sexuallyExcessiveFocusOnBodyDescription
            sexuallyLanguageOfSecrecyOrConcealment
            sexuallyRoleplayOrFantasyContext
            sexuallyViolenceOverlap
            sexuallyNudityDetected
            sexuallyNudityExtent
            sexuallyNudityType
            sexuallySexualActsDetected
            sexuallyIntentDetected
            sexuallyRatingReason
            religiousReligionKeywordsFound
            religiousKeywordList
            religiousReligionsNamed
            religiousFirstOrSecondPersonPronouns
            religiousMiracleMentionedHow
            religiousExplicitOrImplicit
            religiousWhoSaysIt
            religiousTone
            religiousToneConfidence
            religiousReligiousSlangFound
            religiousReligiousSlangList
            religiousHistoricSlursFound
            religiousHistoricSlurList
            religiousMetaphoricReligiousTermFound
            religiousMetaphoricReligiousTermList
            religiousDisrespectTowardsReligion
            religiousDisrespectTriggerList
            religiousDisrespectedReligions
            religiousComparisonFrameDetected
            religiousComparedReligions
            religiousDoctrineClaimType
            religiousFramingStrength
            religiousDraftStanceByReligion
            religiousOverallBiasScore
            religiousReasonNote
            sexuallyFinalRating
          }
        }
      }
    }
  }
`);

export const GET_RELIGIOUS_TRANSPARENCY_ANALYSES =
  gql(`query ReligiousTransparencies_connection($filters: ReligiousTransparencyFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  religiousTransparencies_connection(filters: $filters, pagination: $pagination, sort: $sort) {
    pageInfo {
      total
      page
      pageSize
      pageCount
    }
    nodes {
      documentId
      aiStages
      religionKeywordsFound
      keywordList
      religionsNamed
      firstOrSecondPersonPronouns
      miracleMentionedHow
      explicitOrImplicit
      whoSaysIt
      tone
      toneConfidence
      religiousSlangFound
      religiousSlangList
      historicSlursFound
      historicSlurList
      metaphoricReligiousTermFound
      metaphoricReligiousTermList
      disrespectTowardsReligion
      disrespectTriggerList
      disrespectedReligions
      comparisonFrameDetected
      comparedReligions
      doctrineClaimType
      framingStrength
      draftStanceByReligion
      overallBiasScore
      reasonNote
      outputTokens
      totalTokens
      inputPrice
      outputPrice
      totalPrice
      inputTokens
        book {
          title
          tokenCounts
          priceCounts
        }
        section {
          tokenCounts
          documentId
          priceCounts
        }
      subSection {
             documentId
          paragraphNumber
          pageNumber
          paragraph
        feedback {
          documentId
          religiousClientComments
          religiousUpvote
          religiousDownvote
          uuid
          religiousReligionKeywordsFound
          religiousKeywordList
          religiousReligionsNamed
          religiousFirstOrSecondPersonPronouns
          religiousMiracleMentionedHow
          religiousExplicitOrImplicit
          religiousWhoSaysIt
          religiousTone
          religiousToneConfidence
          religiousReligiousSlangFound
          religiousReligiousSlangList
          religiousHistoricSlursFound
          religiousHistoricSlurList
          religiousMetaphoricReligiousTermFound
          religiousMetaphoricReligiousTermList
          religiousDisrespectTowardsReligion
          religiousDisrespectTriggerList
          religiousDisrespectedReligions
          religiousComparisonFrameDetected
          religiousComparedReligions
          religiousDoctrineClaimType
          religiousFramingStrength
          religiousDraftStanceByReligion
          religiousOverallBiasScore
          religiousReasonNote
          religiousRatingReason
          religiousFinalRating
          createdAt
          updatedAt
          publishedAt
        }
      }
      createdAt
      updatedAt
      publishedAt
    }
  }
}`);
